// You can write your custom Javascript here
$(document).ready(function(){
  
//   var a = window.location.href;
//   var parts = a.split("/");
//   console.log(parts);
//   var tmp = parts[parts.length - 1].split("+");
  
//   console.log(tmp);
  
//   var i;
//   var result;
//   for (i = 0; i < tmp.length; ++i) {
//        result = '.'+ tmp[i];
//     	$(result).addClass("selected");
//   }
  
  
//   var listItems = $(".bc-sf-filter-option-block .bc-sf-filter-block-content .bc-sf-filter-option-single-list li");
//   listItems.each(function(idx, li) {
    
//     $(li).find('a').click(function (e) {
//       e.preventDefault();
      
//       var tag = $(this).attr("class");
//       console.log(tmp);
//       if(tmp.length > 0) {
//           var url = document.location.href+"+"+tag;
//       }else{
//           var url = document.location.href+tag;
//       }
      
      
      
//       document.location = url;
      
//     });

//       // and the rest of your code
//   });
 
  const checkoutBtn = document.querySelector('.js-btn-checkout')
 
  if(checkoutBtn) {
    checkoutBtn.addEventListener('click', (e) => {
      e.preventDefault();
  
      const form = checkoutBtn.closest('form');
      const select = form.querySelector('[name="id"]');
      const quantity = form.querySelector('[name="quantity"]');
      const formData = {
        'items': [{
          'id': select.value,
          'quantity': quantity.value
        }]
      };
  
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if(!response.ok) {
          throw new Error(response.statusText);
        }
  
        window.location.href = window.Shopify.routes.root + 'checkout';
      })
      .catch((error) => {
        console.error('Error:', error);
        alert(error);
      });
    });
  }
});

